export const DOIS_MB = 2097152;
export const DEZ_MB = 10485760;